import { render, staticRenderFns } from "./BarChart.component.vue?vue&type=template&id=0ebbcc9a&scoped=true&"
import script from "./BarChart.component.vue?vue&type=script&lang=ts&"
export * from "./BarChart.component.vue?vue&type=script&lang=ts&"
import style0 from "./BarChart.component.vue?vue&type=style&index=0&id=0ebbcc9a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ebbcc9a",
  null
  
)

export default component.exports